import React from 'react';
import './MobileAbout.css';
import backgroundImage from '../../assets/basketball-bg.jpg';
import { useScrollAnimation } from '../../hooks/useScrollAnimation';

interface TeamMember {
  name: string;
  role: string;
  bio: string;
  image?: string;
}

interface MobileAboutProps {
  teamMembers: TeamMember[];
}

const MobileAbout: React.FC<MobileAboutProps> = ({ teamMembers }) => {
  useScrollAnimation([]);

  return (
    <div className="mobile-about">
      <div className="mobile-about-hero" style={{ backgroundImage: `linear-gradient(rgba(0,0,0,0.7), rgba(0,0,0,0.7)), url(${backgroundImage})` }}>
        <h1 className="mobile-about-title scroll-animate">ABOUT<br />US</h1>
      </div>
      
      <div className="mobile-about-content">
        <div className="mobile-about-section scroll-animate">
          <h2>Our Mission</h2>
          <div className="mobile-about-text scroll-animate">
            <p>Basketball is more than a game, it is a culture which influences multiple areas in society, such as music, art, fashion and community. We believe in the cultural importance of basketball which has played a pivotal role on the courts for at-risk youth and community.</p>
            
            <p>Globally basketball traces its roots back to the streets, ghettos and amazing young people; intertwining with music and urban art. The sport has flourished today alongside urban culture and art, with graffiti walls serving as a backdrop to the rhythms of hip-hop and R&B music.</p>
            
            <p>Also today more than ever, the sneaker culture and fashion has become an essential aspect of basketball culture. It has influenced street wear with professional basketball players serving as an inspiration for urban fashion trends.</p>
            
            <p>Just like how basketball culture intertwines in all these areas and brings people of all walks of life together, we wish to do the same with our podcast by presenting guests from across all these areas and learn how the game has shaped, brought life lessons and made our guests who they are today.</p>
          </div>
        </div>

        <div className="mobile-about-section">
          <h2>The Team</h2>
          <div className="mobile-team-members">
            {teamMembers.map((member, index) => (
              <div className={`mobile-team-member scroll-animate ${!member.image ? 'no-image' : ''}`} key={index}>
                {member.image && (
                  <div className="mobile-member-image">
                    <img src={member.image} alt={member.name} />
                  </div>
                )}
                <div className="mobile-member-info scroll-animate">
                  <h3>{member.name}</h3>
                  <p className="mobile-role">{member.role}</p>
                  <p className="mobile-bio">{member.bio}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default MobileAbout; 